import React from "react";

import { sanitize } from "dompurify";

import ResumeForm from "./components/ResumeForm";

import { selectSetting } from "../../../../features/global/globalSlice";
import { useAppSelector } from "../../../../hooks/reduxHooks";

const Resume = (): React.JSX.Element => {
    const resumeText = useAppSelector(state =>
        selectSetting(state, "majorybl_resume_text"),
    );

    return (
        <section className="teamResume" data-testid="teamResume">
            <div
                dangerouslySetInnerHTML={{
                    __html: sanitize(resumeText?.setting),
                }}
            />
            <ResumeForm />
        </section>
    );
};

export default Resume;
